import React, { useCallback } from 'react';

import { pageTemplateProps } from '@xengage/gw-portals-wizard-react';
import WizardPageHeader from '../../components/WizardPageHeader/WizardPageHeader'
import WizardSingleErrorComponent from '../../../WizardSingleErrorComponent/WizardSingleErrorComponent'
// import DigitalWizardPageTemplate from '../DigitalWizardPageTemplate';
import DigitalWizardCustPageTemplate from '../cpmi_DigitalWizardPageTemplate/DigitalWizardCustPageTemplate';


import styles from './DigitalWizardCustPageWithTitleTemplate.module.scss';

function DigitalWizardCustPageWithTitleTemplate(props) {
    const {
        children, acknowledgeError, errorsForStep, isSideHeader, ...otherProps
    } = props;

    const renderWizardHeader = useCallback(
        (wizardData) => {
          let  getSubmissionVM = wizardData?.submissionVM || wizardData;
            if(props?.wizardData?.lossDate?.day){
                 getSubmissionVM = props?.wizardData;
                let toShowDOI= getSubmissionVM?.fnolSelectPolicyPage;
                return (
                    <WizardPageHeader showDOI={toShowDOI} wizardSubmission={getSubmissionVM} isSideHeader={isSideHeader} />
                );
            }
           else{
                return (
                    <WizardPageHeader  wizardSubmission={getSubmissionVM} isSideHeader={isSideHeader} />
                );
            }
        },
        [isSideHeader,props?.wizardData]
    );

    return (
        <div className={styles.wizardContainer}>
            <DigitalWizardCustPageTemplate
                renderContextComponent={renderWizardHeader}
                showContextComponent={false}
                showWizardHeader
                {...otherProps}
            >
                <WizardSingleErrorComponent
                    acknowledgeError={acknowledgeError}
                    issuesList={errorsForStep}
                />
                {children}
            </DigitalWizardCustPageTemplate>
        </div>
    );
}

DigitalWizardCustPageWithTitleTemplate.propTypes = pageTemplateProps;
export default DigitalWizardCustPageWithTitleTemplate;